module.exports = __webpack_public_path__ + "img/744.765133b4.jpg";